import { AxiosError } from 'axios/lib/core/AxiosError';
import { toast } from 'react-toastify';
import { isClientSide } from 'src/utils/constants';
import logger from 'src/utils/logger';
import { INTERNAL_API_ERROR_CODE } from './constants';
import { APIError, RequestParams } from './types';

const generalProps = {
  position: 'top-center',
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  // use timestamp as id if no id is provided
  toastId: `toastId-${Math.floor(Date.now() / 1000)}`
};

const commonErrors = {
  UK: {
    errNetwork: `Шановний користувач, можливі помилки в роботі сайту через ваш нестабільний інтернет.`
  },
  RU: {
    errNetwork:
      'Уважаемый пользователь, возможны ошибки в работе сайта из-за нестабильного интернета у вас.'
  }
};

const handleAPIError = (
  error: AxiosError,
  requestObj?: RequestParams,
  locale?: string
): APIError => {
  const apiError = new APIError(
    error?.code || error?.status || INTERNAL_API_ERROR_CODE,
    error?.message,
    // eslint-disable-next-line
    // @ts-ignore
    error?.response?.data,
    requestObj
  );
  if (apiError.code === 'ERR_NETWORK') {
    toast.error(
      commonErrors[locale]?.errNetwork,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      { ...generalProps }
    );
  }
  logger.log(apiError);
  // throw error for client side only because next.js cannot handle throw from SSR on it's own
  if (isClientSide) {
    throw apiError;
  }
  return apiError;
};

export default handleAPIError;
